import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-toolbar',
  templateUrl: './fm-toolbar.component.html',
  styleUrls: ['./fm-toolbar.component.scss'],
})
export class FmToolbarComponent {}
